<template>
  <div>
    <PCNavbar selectIndex="4"/>
    <MobileNavBar :currentActive="3" />
    <serviceSupport/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import serviceSupport from '@/components/serviceSupport/index.vue'
import router from '../router';
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    serviceSupport
  },
}
</script>

<style>
</style>